var _excluded = ["apiStatus", "apiStatusAttributesConfig", "apiStatusHtmlAttributesConfig", "htmlAttributes"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
import * as React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import reduce from 'lodash/reduce';
import { hoistStatics } from 'recompose';
import { API_BEFORE_SEND } from "../../constants/sharedConstants";

/**
 * Extract the attributes from the config object
 */
var extractAttributesByApiStatus = function extractAttributesByApiStatus(_ref) {
  var config = _ref.config,
    apiStatus = _ref.apiStatus;
  // $FlowFixMe
  return reduce(config, function (memo, item, key) {
    return _objectSpread(_objectSpread({}, memo), {}, _defineProperty({}, key, item[apiStatus]));
  }, {});
};

/**
 * A HOC to customize UI display based on the configs of different apiStatus
 * Ref: bundles/admin-dashboard-programs/components/members/ProgramSingleInvite.jsx
 * It works well with Button, but can also be applied to any kinds of component
 * Separate the config into attributes and htmlAttributes for clarity
 */
export default function withApiStatusUIInfo(Component) {
  var HOC = function HOC(_ref2) {
    var _ref2$apiStatus = _ref2.apiStatus,
      apiStatus = _ref2$apiStatus === void 0 ? API_BEFORE_SEND : _ref2$apiStatus,
      _ref2$apiStatusAttrib = _ref2.apiStatusAttributesConfig,
      apiStatusAttributesConfig = _ref2$apiStatusAttrib === void 0 ? {} : _ref2$apiStatusAttrib,
      _ref2$apiStatusHtmlAt = _ref2.apiStatusHtmlAttributesConfig,
      apiStatusHtmlAttributesConfig = _ref2$apiStatusHtmlAt === void 0 ? {} : _ref2$apiStatusHtmlAt,
      htmlAttributes = _ref2.htmlAttributes,
      rest = _objectWithoutProperties(_ref2, _excluded);
    // Extract the attributes based on the apiStatus and add to the component props
    var attributesByApiStatus = extractAttributesByApiStatus({
      apiStatus: apiStatus,
      config: apiStatusAttributesConfig
    });
    var htmlAttributesByApiStatus = extractAttributesByApiStatus({
      apiStatus: apiStatus,
      config: apiStatusHtmlAttributesConfig
    });
    var htmlAttributesLocal = _objectSpread(_objectSpread({}, htmlAttributes), htmlAttributesByApiStatus);
    var htmlAttributesProp = isEmpty(htmlAttributesLocal) ? {} : {
      htmlAttributes: htmlAttributesLocal
    };
    return /*#__PURE__*/React.createElement(Component, _extends({}, rest, attributesByApiStatus, htmlAttributesProp));
  };
  HOC.propTypes = {
    apiStatus: PropTypes.string,
    apiStatusAttributesConfig: PropTypes.object,
    apiStatusHtmlAttributesConfig: PropTypes.object,
    htmlAttributes: PropTypes.object
  };
  var componentName = String(Component.displayName || Component.name);
  HOC.displayName = "withApiStatusUIInfo(".concat(componentName, ")");
  // $FlowFixMe
  hoistStatics(Component, HOC);
  return HOC;
}